import { useState } from 'react';
import initialSoWData from '../data/initialDetails.json';

const initializeFormState = (data) => {
    const formState = {};
    for (const key in data) {
        formState[key] = {
            value: data[key],
            locked: true // All fields are locked by default
        };
    }
    return formState;
};

export const useSoWForm = () => {
    const [formData, setFormData] = useState(() => initializeFormState(initialSoWData));
    const [isLoading, setIsLoading] = useState(false); // Add isLoading state

    const handleFieldChange = (key, newValue) => {
        setFormData(prevData => ({
            ...prevData,
            [key]: { ...prevData[key], value: newValue }
        }));
    };

    const handleLockToggle = (key) => {
        setFormData(prevData => ({
            ...prevData,
            [key]: { ...prevData[key], locked: !prevData[key].locked }
        }));
    };

    // Function to update all form data, used for importing JSON
    const updateAllFormData = (newJsonData) => {
        setFormData(initializeFormState(newJsonData));
    };

    // Function to extract only values for export
    const getExportData = () => {
        const exportData = {};
        for (const key in formData) {
            exportData[key] = formData[key].value;
        }
        return exportData;
    };

    const startLoading = () => setIsLoading(true);
    const stopLoading = () => setIsLoading(false);

    return {
        formData,
        handleFieldChange,
        handleLockToggle,
        updateAllFormData,
        getExportData,
        isLoading,        // Return isLoading state
        startLoading,     // Return startLoading function
        stopLoading       // Return stopLoading function
    };
};
